<template>
    <div>
      <div class="indexContainer">
        <el-divider class="indexTitle" v-if="val.title">
            <div class="indexTitleMain">
                <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                <h4>{{val.summary}}</h4>
            </div>
        </el-divider>
      </div>
    <div class="groupGlory">
      <div class="indexContainer bg">
        <div style="position: relative">
          <span class="card-carousel--nav__left" @click="moveCarousel(-1)" :disabled="atHeadOfList">
            <i class="el-icon-back"></i>
          </span>
          <div class="groupGloryMain" style="overflow: hidden;">
              <el-row 
                style="display: flex; transition: transform 150ms ease-out; transform: translatex(0px);"
                :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
                  <el-col :span="6" v-for="(i, index2) in items" :key="index2" style="width: 205px">
                      <div class="line"></div>
                      <p class="year">{{i.title}}</p>
                      <span class="dian">
                          <span></span>
                      </span>
                      <div style="width: 205px">
                        <p class="text" style="width: 205px" v-for="(t, index3) in i.list" :key="index3"><i></i>{{t}}</p>
                      </div>
                  </el-col>
              </el-row>
          </div>
          <span class="card-carousel--nav__right" @click="moveCarousel(1)" :disabled="atEndOfList">
            <i class="el-icon-right"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    val: ''
  },
    data(){
        return{
          currentOffset: 0,
            windowSize: 1,
            paginationFactor: 205,
            items:[]
        }
    },
    computed: {
      atEndOfList() {
        return this.currentOffset <= (this.paginationFactor * -1) * (this.items.length - this.windowSize);
      },
      atHeadOfList() {
        return this.currentOffset === 0;
      },
    },
    created() {
      for(let v of this.val.attaches) {
        if(v.summary) {
          v.list = [...v.summary.split('\n')]
        }
      }
      this.items = this.val.attaches;
    },
    methods: {
        moveCarousel(direction) {
          if (direction === 1 && !this.atEndOfList) {
            this.currentOffset -= this.paginationFactor;
          } else if (direction === -1 && !this.atHeadOfList) {
            this.currentOffset += this.paginationFactor;
          }
        },
    },
    watch: {
      val(val) {
      }
    }
}
</script>
<style lang="less" scoped>
.groupGlory{
    background:#f7f7f7;
    .bg{
        background: url(../../assets/groupGlory.png) no-repeat left top;
        padding:120px 0 50px;
    }
    .card-carousel--nav__left, .card-carousel--nav__right  {
      position: absolute;
      top: 13px;
      background-color:#fff;
      border:1px solid #d82b3d;
      color: #d82b3d;
      width: 36px;
      height: 36px;
      line-height: 36px;
      border-radius: 50%;
      &:hover {
        cursor: pointer;
      }
    }
    .card-carousel--nav__left {
      left: 16px;
    }
    .card-carousel--nav__right {
      right: 16px;
    }
    /deep/ .el-row .el-col:hover {
      cursor: pointer;
      .dian {
        border: 1px solid #f00; 
        span {
          background: #f00;
        } 
      }
    }
    .groupGloryMain{
        margin: 0 70px;
        position: relative;
        .el-col{
            position: relative;
        }
        .line{
            height: 1px;
            top: 32px;
            left: 0;
            right: 0;      
            position: absolute;
            border-color: inherit;
            background-color: #ccc;
        }
        .year{
            font-size: 20px;
            font-weight: 500;
            margin: 0;
        }
        .dian{
            width: 13px;
            height: 13px;
            border-radius: 30px;
            border:1px solid #d7d7d7;
            display: inline-block;
            padding: 2px;
            span{
                width: 12px;
                height: 12px;
                border-radius: 30px;
                background: #999;
                display: inline-block;
                position:relative;
                z-index: 999;
            }
        }
        .text{
          box-sizing: border-box;
            padding: 0 30px;
            // position: relative;
            text-align: left;
            line-height: 24px;
            i{
                width: 4px;
                height: 4px;
                border-radius: 4px;
                background: #333;
                display: inline-block;
                position: relative;
                top:-5px;
                margin-right: 5px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/item/patch26.vue